import React from 'react';
import classNames from 'classnames';

import styles from './base-button.less';

class BaseButton extends React.Component {
  static propTypes = {
    onClick: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    tabIndex: React.PropTypes.number,
    autoFocus: React.PropTypes.bool
  }

  getClass() {
    return classNames(styles.button, this.props.className);
  }

  render() {
    return (
      <button onClick={this.props.onClick}
              className={this.getClass()}
              disabled={this.props.disabled}
              tabIndex={this.props.tabIndex}
              autoFocus={this.props.autoFocus}>
        {this.props.children}
      </button>
    );
  }
}

module.exports = BaseButton;


/** WEBPACK FOOTER **
 ** ./src/buttons/base-button/index.js
 **/